/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Row, Spinner } from 'reactstrap';
import Select from 'react-select';
import Button from '../../Components/Button/Button';
import { getFormsAttached, attachFormsToCustomer } from '../../Service/Api';

class AttachForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forms: [],
            loading: true,
            formSelected: [],
            customStyles: {
                container: () => ({
                    width: '90%',
                    marginLeft: '5%',
                }),
                menu: () => ({
                    marginLeft: 0,
                    width: '100%',
                    position: 'relative',
                    border: '1px solid #dee2e6 !important',
                    borderTop: '0px',
                    borderRadius: '0 0 5px 5px',
                }),
            },
        };
    }

    componentDidMount() {
        const { data } = this.props;
        this.setState({ loading: true });
        getFormsAttached(data.id).then((response) => {
            this.setState({
                forms: this.convertForm(response.data.forms),
                formSelected: this.convertForm(response.data.customer.attached_forms),
            }, () => {
                this.setState({
                    loading: false,
                });
            });
        }).catch((error) => {
            this.handleError(error);
        });
    }

    handleError = (error) => {
        const { status } = error.response;
        if (status === 401 || status === 403) {
            const [, dispatch] = this.context;
            dispatch({
                type: 'EXIT',
            });
        }

        this.setState({ loading: false });
    }

    convertForm = (form) => {
        const data = [];
        form.forEach((item) => {
            data.push({ value: item.id, label: item.name });
        });
        return data;
    }

    onChangeSelect = (data) => {
        this.setState({
            formSelected: data,
        });
    }

    handleSubmit = () => {
        const ids = [];
        const { data, callback } = this.props;
        const { formSelected } = this.state;
        if (formSelected) {
            formSelected.forEach((item) => {
                ids.push(item.value);
            });
        }
        attachFormsToCustomer({ id: data.id, forms: ids })
            .then(() => {
                callback();
            }).catch((error) => {
                this.handleError(error);
            });
    }


    render() {
        const {
            formSelected, customStyles, forms, loading,
        } = this.state;

        return (
            <>
                <Row>
                    {!loading && (
                        <Select
                            defaultValue={formSelected}
                            styles={customStyles}
                            options={forms}
                            isMulti
                            onChange={this.onChangeSelect}
                        />
                    )}
                </Row>
                <div className="form-footer">
                    {loading && <div className="spinner"><Spinner /></div>}
                    <Button text="Asignar" onClick={this.handleSubmit} disabled={loading} />
                </div>
            </>
        );
    }
}


export default AttachForm;
